export const UPDATE_STATUS = 'UPDATE_STATUS'
export const UPDATE_USER_STATUS = 'UPDATE_USER_STATUS'
export const UPDATE_PLACE_STATUS = 'UPDATE_PLACE_STATUS'
export const UPDATE_DESTINATION_STATUS = 'UPDATE_DESTINATION_STATUS'
export const UPDATE_POPULAR_ITEMS_STATUS = 'UPDATE_POPULAR_ITEMS_STATUS'
export const CLEAR_BOARD_STATUS = 'CLEAR_BOARD_STATUS'
export const CLEAR_LIST_STATUS = 'CLEAR_LIST_STATUS'
export const CLEAR_PLACE_STATUS = 'CLEAR_PLACE_STATUS'
